// The Ascension crest. Standalone component — never baked into an image.
// Colours are fixed (no currentColor). For emerald-on-light, swap both
// #F4F6F2 strokes to #0B7A4B via the `emerald` prop.
export default function Crest({ size = 96, emerald = false }) {
  const stroke = emerald ? "#0B7A4B" : "#F4F6F2";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      role="img"
      aria-label="Geskano"
      width={size}
      height={size}
    >
      <g fill="none" stroke={stroke} strokeWidth="5" strokeLinecap="round">
        <path d="M 27.68 22 A 33 33 0 1 0 68.32 22" />
      </g>
      <g fill="#E0A93B">
        <path d="M 33.02 13 L 31.67 16.74 L 27.69 16.87 L 30.83 19.31 L 29.73 23.13 L 33.02 20.9 L 36.31 23.13 L 35.21 19.31 L 38.34 16.87 L 34.37 16.74 Z M 48 9.4 L 46.65 13.14 L 42.67 13.27 L 45.81 15.71 L 44.71 19.53 L 48 17.3 L 51.29 19.53 L 50.19 15.71 L 53.33 13.27 L 49.35 13.14 Z M 62.98 13 L 61.63 16.74 L 57.66 16.87 L 60.79 19.31 L 59.69 23.13 L 62.98 20.9 L 66.27 23.13 L 65.17 19.31 L 68.31 16.87 L 64.33 16.74 Z" />
      </g>
      <g fill="none" stroke={stroke} strokeWidth="7.5" strokeLinecap="round">
        <path d="M 26 57 L 45 42.5 M 70 57 L 51 42.5 M 30 67 L 45 54.5 M 66 67 L 51 54.5" />
      </g>
    </svg>
  );
}
